import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { setIsSideDrawerOpen } from '../../features/navigation/slices/navigationReducer';
import ProfileDropdown from '../../features/profile/components/ProfileDropdown';
import FindABlogSearchComponent from '../../features/search/components/FindABlogSearchComponent';
import WNButton from '../FormComponents/WNButton';

const HomeHeadingComponent = (props: HeadingProps) => {
  const { headingText } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isLoggedIn = useSelector((state: AppState) => state.user.isLoggedIn);
  const isSideDrawerOpen = useSelector(
    (state: AppState) => state.nav.isSideDrawerOpen
  );
  const unreadNotificationsCount = useSelector(
    (state: AppState) => state.notifications.unreadCount
  );

  const handleNotificationsClick = () => {
    navigate('/notifications');
  };

  const handleLoginClick = () => {
    navigate('/login-or-signup');
  };

  const handleCreateList = () => {
    if (!isLoggedIn) {
      navigate('/login-or-signup');
      return;
    }
    navigate('/create-curated-list');
  };

  const handleUploadBlogClick = () => {
    if (!isLoggedIn) {
      navigate('/login-or-signup');
      return;
    }
    navigate('/upload-blog');
  };

  return (
    <div className="home-heading-wrapper">
      <div className="header-left-group">
        <MenuIcon
          className="hamburger-menu-toggle"
          onClick={() => dispatch(setIsSideDrawerOpen(!isSideDrawerOpen))}
        />
        <img
          src="/assets/images/Logo.png"
          alt="The WilderNet"
          className="header-logo"
          onClick={() => navigate('/')}
        />
      </div>

      <FindABlogSearchComponent />

      <div className="header-actions">
        {/* Desktop Only: Show buttons | Mobile: They're in the side drawer */}
        <div className="desktop-only header-buttons">
          <div className="header-button-tooltip-wrapper">
            <WNButton
              buttonText="Add a Blog"
              optionalClass="header-button"
              onClick={handleUploadBlogClick}
              isSecondary={true}
            />
            <div className="header-tooltip">
              {!isLoggedIn ? "Sign in to share a blog" : "Add a blog to The WilderNet!"}
            </div>
          </div>

          <div className="header-button-tooltip-wrapper">
            <WNButton
              buttonText="Create a Trail"
              optionalClass="header-button"
              onClick={handleCreateList}
              isSecondary={true}
            />
            <div className="header-tooltip">
              {!isLoggedIn ? "Sign in to create a list" : "Create a list of things you like!"}
            </div>
          </div>
        </div>

        {/* Notifications only show when logged in */}
        {isLoggedIn && (
          <div
            className="notification-icon-wrapper"
            onClick={handleNotificationsClick}
            title="Notifications"
            aria-label="Notifications"
          >
            <NotificationsNoneIcon className="notification-icon" />
            {unreadNotificationsCount > 0 && (
              <span className="notification-badge">
                {unreadNotificationsCount}
              </span>
            )}
          </div>
        )}

        {/* Show profile dropdown when logged in, otherwise show Login button */}
        {isLoggedIn ? (
          <ProfileDropdown />
        ) : (
          <Button
            variant="text"
            className="login-nav-button"
            onClick={handleLoginClick}
          >
            Login
          </Button>
        )}
      </div>
    </div>
  );
};

export default HomeHeadingComponent;